import getCategoryList from './getCategoryList'
import getCategorySelected from './getCategorySelected'

export const getCategoryListAPI = getCategoryList
export const getCategorySelectedAPI = getCategorySelected
